import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { ExternalLink } from '../../components';

import css from './AboutPage.module.css';

import element1 from '../../assets/team-shape1.png';
import element2 from '../../assets/team-shape2.png';
import element3 from '../../assets/team-shape3.png';
import element4 from '../../assets/team-shape4.png';

import european from '../../assets/logos/European.jpg';
import eleven from '../../assets/logos/Eleven.jpg';
import frc from '../../assets/logos/FRC.png';

function SectionOurTeamTest() {
  // Array of team members
  const teamMembers = [
    {
      imageUrl: eleven,
      altText: 'Nikolaos Vlahos, M.D, F.A.C.O.G.',
      websiteUrl: 'https://www.11.vc/',
    },
    {
      imageUrl: frc,
      altText: 'Beth Hirschhorn',
      websiteUrl: 'https://www.filrougecapital.com/',
    },
    // {
    //   imageUrl: european,
    //   altText: 'Dr. Sabine Wünschmann',
    //   websiteUrl: 'https://european-union.europa.eu/index_en',
    // }
  ];

  const TeamMember = ({ imageUrl, altText, websiteUrl }) => {
    return (
      <div className={css.team}>
        <div className={css.teamInfo}>
          <div className={css.investorImg}>
            <ExternalLink href={websiteUrl}>
              <img src={imageUrl} alt={altText} />
            </ExternalLink>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={css.ourTeamContainer}>
      <span className={css.shape1}>
        <img src={element1} alt="element" />
      </span>
      <span className={css.shape2}>
        <img src={element2} alt="element" />
      </span>
      <span className={css.shape3}>
        <img src={element3} alt="element" />
      </span>
      <span className={css.shape4}>
        <img src={element4} alt="element" />
      </span>
      <div className={css.contentWidth}>
        <section className={css.ourTeamContent}>
          <h2>
            <FormattedMessage id="AboutPage.investors" />
          </h2>
          <div className={css.teamBlock}>
            {teamMembers.map((member, index) => (
              <TeamMember key={index} {...member} />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default SectionOurTeamTest;
